import { jsx as _jsx } from "react/jsx-runtime";
import { LCATProgressView } from './LCATProgressView';
/**
 * Renders an LCAT progress message part
 * Shows the 9-step pipeline progress with real-time updates
 *
 * IMPORTANT: Only the FIRST progress event for a given LCAT run ID should render.
 * All subsequent events with the same ID will update the same component via the hook.
 */ export function LCATProgressPart({ part, messageId, index }) {
    if (!part.data) {
        return null;
    }
    // Only render if this is the first event (initialization step) for this LCAT run
    // All subsequent progress updates will be handled by the LCATProgressView hook
    const isFirstEvent = part.data.step === 'initialization' || !part.data.id;
    if (!isFirstEvent) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "w-full",
        children: /*#__PURE__*/ _jsx(LCATProgressView, {
            messageId: messageId,
            lcatRunId: part.data.id
        })
    }, `${messageId}-lcat-progress-${part.data.id || index}`);
}
